import React, { useState, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";

import { API } from "../../../Common/lib/api";

import Project from "../Project";
import deleteProject from "../DeleteProject";
import doiRequest from "../RequestDOI";

import { getUserSession } from "../../../Common/lib/Session";

import ResponseNotification from "../../Admin/UserManagement/Modals/responseNotification";

export default function ContributionsTab() {
  const [projects, setProjects] = useState([]);
  const [contributorAccess, setContributorAccess] = useState(false);
  const [userProfile, setUserProfile] = useState({
    username: "",
    email: "",
    fname: "",
    lname: "",
    institute: "",
    phone_number: "",
    research_field: "",
    research_geo: "",
    is_staff: false,
    contributor_access: false,
  });

  const [notificationShow, setNotificationShow] = useState(false);
  const [notificationPurpose, setNotificationPurpose] = useState("");

  const [notification, setNotification] = useState({
      status: false,
      title: "",
      message: "",
  });

  let history = useHistory();

  useEffect(() => {
    const init = async () => {
      const session = await getUserSession();

      setUserProfile({
        username: session.username,
        email: session.email,
        fname: session.fname,
        lname: session.lname,
        institute: session.institute,
        phone_number: session.phone_number,
        research_field: session.research_field,
        research_geo: session.research_geo,
        is_staff: session.is_staff,
        contributor_access: session.contributor_access,
      });

      const hasContributorAccess =
        session.is_staff ||
        session.contributor_access === true ||
        session.contributor_access === "true";

      setContributorAccess(hasContributorAccess);

      const params = {
        createdByUserId: session.id,
      };
      
      const projectsResponse = await API.projects.list(params);
      const items = projectsResponse.data.listProjects?.items || projectsResponse.data?.items || [];
      setProjects(items);
    };

    init();
  }, []);

  async function removeProject(projectId, sk, title, setOpenDeleteModal) {
    const project = await deleteProject(projectId, sk, title);

    setProjects((prevState) => prevState.filter((project) => project.id !== projectId));
    setOpenDeleteModal(false);
  }

  async function requestDOI(projectId, title, doi) {
    try{
      const project = await doiRequest(projectId, title, doi);

      setProjects((prevState) => {
        let newState = [...prevState];
        let projectIndex = prevState.findIndex(project => project.id === projectId)

        const updatedProject = {...prevState[projectIndex]};
        updatedProject.DOI = "Requested";
        newState[projectIndex] = updatedProject;

        return newState
      });

      setNotificationShow(true);
      setNotificationPurpose("DOI");
      setNotification({
          status: true,
          title: "DOI Request",
          message: `A Digital Object Identifier has been requested.`
      });
    }
    catch(err){
      setNotificationShow(true);
      setNotificationPurpose("DOI");
      setNotification({
        status: false,
        title: "An Error has occurred",
        message: `A DOI can not be requested at this time.`
      });
      // console.log(err)
    }
  }

  return (
    <>
      <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
        {projects.filter(project => project.publishStatus !== "archived").length > 0 ? (
          projects
            .filter((project) => project.publishStatus !== "archived")
            .map((project) => (
              <Project
                key={project.id || project.PK || project.projectID}
                userProfile={userProfile}
                project={project}
                removeProject={removeProject}
                requestDOI={requestDOI}
              />
            ))
        ) : (
          <>
            <div className="flex flex-1 flex-col items-center py-12 rounded-xl border-2 border-dashed border-gray-300 bg-gray-50 outline-none sm:mb-28 mb-0 dark:bg-gray-800 dark:border-gray-700">
              <p className="text-gray-600 text-base mb-1 dark:text-gray-400">No contributions have been made.</p>
              {contributorAccess && (
                <button
                  type="button"
                  onClick={() => history.push("/submit-data")}
                  className="mt-3 flex justify-center py-2 px-6 border rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 "
                >
                  Submit Dataset
                </button>
              )}
            </div>
          </>
        )}

        {/* Creates space on the bottom if there's less than 3 projects to prevent white space below the footer */}
        {projects.length < 3 && <div className="pb-80"></div>}

        <ResponseNotification
          as={Fragment}
          show={notificationShow}
          notification={notification}
          setShow={setNotificationShow}
          notificationPurpose={notificationPurpose}
        />
      </div>
    </>
  );
}